var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterConcepts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-filter-2",
    "data-name": "icon-filter",
    d: "M3,13a.669.669,0,0,0,.667.667H7V12.333H3.667A.669.669,0,0,0,3,13ZM3,5a.669.669,0,0,0,.667.667h6V4.333h-6A.669.669,0,0,0,3,5Zm6.667,9.333v-.667h4.667a.667.667,0,1,0,0-1.333H9.667v-.667a.667.667,0,0,0-1.333,0v2.667a.667.667,0,0,0,1.333,0Zm-4-6.667v.667h-2a.667.667,0,0,0,0,1.333h2v.667a.667.667,0,0,0,1.333,0V7.667a.667.667,0,1,0-1.333,0ZM15,9a.669.669,0,0,0-.667-.667h-6V9.667h6A.669.669,0,0,0,15,9ZM11.667,7a.669.669,0,0,0,.667-.667V5.667h2a.667.667,0,1,0,0-1.333h-2V3.667a.667.667,0,0,0-1.333,0V6.333A.669.669,0,0,0,11.667,7Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterConcepts);
export default __webpack_public_path__ + "static/media/icon-filter-concepts.d6628520.svg";
export { ForwardRef as ReactComponent };